import React from "react";
import { LessonRecording } from "../common/api";
import { LessonRecordingItemBody } from "./LessonRecordingItemBody";
import {
  AnalyticsContext,
  ViewLessonRecordingEvent,
} from "../common/context/AnalyticsContext";

export const LessonRecordingItem = ({
  recording,
  onMenuButtonClick,
}: {
  recording: LessonRecording;
  onMenuButtonClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const { logEvent } = React.useContext(AnalyticsContext);
  return recording.is_ready ? (
    <a
      href={recording.video_url}
      style={{ textDecoration: "none" }}
      onClick={() => {
        logEvent(new ViewLessonRecordingEvent(recording.id));
      }}
    >
      <LessonRecordingItemBody
        recording={recording}
        onMenuButtonClick={onMenuButtonClick}
      />
    </a>
  ) : (
    <LessonRecordingItemBody
      recording={recording}
      onMenuButtonClick={onMenuButtonClick}
    />
  );
};
